export default function (instance) {
  instance.customInterval = (callback, delay, options = {}) => {
    const { immediate = false } = options;

    if (immediate) {
      callback();
    }

    const intervalId = setInterval(() => {
      if (!instance || instance.$destroyed) {
        clearInterval(intervalId);

        return;
      }

      try {
        callback();
      } catch (error) {
        console.error('[customInterval]', error);
        clearInterval(intervalId);
      }
    }, delay);

    instance.attachEvent('onDestroy', () => {
      clearInterval(intervalId);
    });

    return () => clearInterval(intervalId);
  };
}
